import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

const Terms = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Algemene Voorwaarden | Bo Barbers Utrecht"
        description="De algemene voorwaarden van Bo Barbers: afspraken, betaling, levering, retour, aansprakelijkheid en huisregels."
        path="/terms"
      />
      <Header />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-foreground">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-4xl mx-auto text-center">
            <p className="text-white/60 uppercase tracking-[0.3em] mb-6 text-xs font-semibold">
              Juridisch
            </p>
            <h1 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-6">
              Algemene Voorwaarden
            </h1>
            <div className="w-24 h-1 bg-white mx-auto"></div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 sm:py-24">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-3xl mx-auto prose prose-lg">
            <div className="space-y-8 text-foreground/80">
              <div>
                <p className="text-sm text-muted-foreground mb-8">
                  Laatst bijgewerkt: December 2024
                </p>
              </div>

              <div>
                <h2 className="font-display text-2xl font-bold text-foreground mb-4">Artikel 1 - Definities</h2>
                <p className="leading-relaxed">
                  In deze algemene voorwaarden wordt verstaan onder:<br /><br />
                  <strong>Bo Barbers:</strong> de eenmanszaak Bo Barbers, gevestigd aan de Twijnstraat 46 te Utrecht.<br />
                  <strong>Klant:</strong> de natuurlijke persoon die een overeenkomst aangaat met Bo Barbers.<br />
                  <strong>Diensten:</strong> alle door Bo Barbers aangeboden kappersbehandelingen en baardverzorging.<br />
                  <strong>Producten:</strong> alle door Bo Barbers verkochte verzorgingsproducten.
                </p>
              </div>

              <div>
                <h2 className="font-display text-2xl font-bold text-foreground mb-4">Artikel 2 - Toepasselijkheid</h2>
                <p className="leading-relaxed">
                  Deze algemene voorwaarden zijn van toepassing op alle aanbiedingen, bestellingen en overeenkomsten van Bo Barbers. Door het maken van een afspraak of het plaatsen van een bestelling accepteert de klant deze algemene voorwaarden.
                </p>
              </div>

              <div>
                <h2 className="font-display text-2xl font-bold text-foreground mb-4">Artikel 3 - Afspraken</h2>
                <p className="leading-relaxed mb-4">
                  3.1 Afspraken kunnen online, telefonisch of via social media worden gemaakt.<br /><br />
                  3.2 Bij verhindering dient de klant de afspraak minimaal 24 uur van tevoren te annuleren. Bij herhaaldelijk niet nakomen van afspraken zonder tijdige afmelding behoudt Bo Barbers zich het recht voor om toekomstige boekingen te weigeren.<br /><br />
                  3.3 Bo Barbers streeft ernaar klanten op de afgesproken tijd te helpen, maar kan niet aansprakelijk worden gesteld voor eventuele wachttijd door uitloop van eerdere behandelingen.
                </p>
              </div>

              <div>
                <h2 className="font-display text-2xl font-bold text-foreground mb-4">Artikel 4 - Prijzen en Betaling</h2>
                <p className="leading-relaxed">
                  4.1 Alle prijzen zijn in euro's en inclusief BTW.<br /><br />
                  4.2 Betaling voor diensten geschiedt direct na de behandeling, contant of per pin.<br /><br />
                  4.3 Betaling voor online bestellingen geschiedt vooraf via de aangeboden betaalmethoden.<br /><br />
                  4.4 Bo Barbers behoudt zich het recht voor om prijzen te wijzigen. Gewijzigde prijzen gelden niet voor reeds gemaakte afspraken of geplaatste bestellingen.
                </p>
              </div>

              <div>
                <h2 className="font-display text-2xl font-bold text-foreground mb-4">Artikel 5 - Levering Producten</h2>
                <p className="leading-relaxed">
                  5.1 Bestellingen worden zo snel mogelijk verzonden, doorgaans binnen 2-3 werkdagen.<br /><br />
                  5.2 Verzendkosten bedragen €6,95 voor bestellingen onder €50. Bestellingen vanaf €50 worden gratis verzonden.<br /><br />
                  5.3 Bo Barbers is niet aansprakelijk voor vertragingen bij de bezorging die worden veroorzaakt door de vervoerder.
                </p>
              </div>

              <div>
                <h2 className="font-display text-2xl font-bold text-foreground mb-4">Artikel 6 - Retourbeleid</h2>
                <p className="leading-relaxed">
                  6.1 De klant heeft het recht om binnen 14 dagen na ontvangst van de producten de koopovereenkomst zonder opgave van redenen te ontbinden.<br /><br />
                  6.2 Producten dienen in originele, ongeopende verpakking te worden geretourneerd.<br /><br />
                  6.3 Kosten voor retourzending zijn voor rekening van de klant.<br /><br />
                  6.4 Terugbetaling vindt plaats binnen 14 dagen na ontvangst van de geretourneerde producten.
                </p>
              </div>

              <div>
                <h2 className="font-display text-2xl font-bold text-foreground mb-4">Artikel 7 - Aansprakelijkheid</h2>
                <p className="leading-relaxed">
                  7.1 Bo Barbers is niet aansprakelijk voor schade ontstaan door onjuiste informatie verstrekt door de klant.<br /><br />
                  7.2 De aansprakelijkheid van Bo Barbers is te allen tijde beperkt tot het bedrag dat de klant heeft betaald voor de betreffende dienst of het product.<br /><br />
                  7.3 Bo Barbers is niet aansprakelijk voor allergische reacties, tenzij de klant vooraf duidelijk heeft aangegeven allergisch te zijn voor bepaalde producten of ingrediënten.
                </p>
              </div>

              <div>
                <h2 className="font-display text-2xl font-bold text-foreground mb-4">Artikel 8 - Klachten</h2>
                <p className="leading-relaxed">
                  8.1 Klachten over de uitgevoerde diensten dienen zo spoedig mogelijk, maar uiterlijk binnen 7 dagen na de behandeling, te worden gemeld.<br /><br />
                  8.2 Klachten kunnen worden ingediend via info@bobarbers.nl of telefonisch via 030 720 0 888.<br /><br />
                  8.3 Bo Barbers zal de klacht zo spoedig mogelijk behandelen en streeft naar een passende oplossing.
                </p>
              </div>

              <div>
                <h2 className="font-display text-2xl font-bold text-foreground mb-4">Artikel 9 - Huisregels</h2>
                <p className="leading-relaxed">
                  9.1 In de salon wordt een respectvolle omgang verwacht tussen klanten en medewerkers.<br /><br />
                  9.2 Onder invloed van alcohol of drugs wordt geen toegang verleend.<br /><br />
                  9.3 Bij storend of agressief gedrag kan de behandeling worden geweigerd of gestaakt.
                </p>
              </div>

              <div>
                <h2 className="font-display text-2xl font-bold text-foreground mb-4">Artikel 10 - Toepasselijk Recht</h2>
                <p className="leading-relaxed">
                  Op alle overeenkomsten tussen Bo Barbers en de klant is Nederlands recht van toepassing. Geschillen worden voorgelegd aan de bevoegde rechter te Utrecht.
                </p>
              </div>

              <div>
                <h2 className="font-display text-2xl font-bold text-foreground mb-4">Contact</h2>
                <p className="leading-relaxed">
                  Voor vragen over deze algemene voorwaarden kunt u contact opnemen met:<br /><br />
                  Bo Barbers<br />
                  Twijnstraat 46<br />
                  3511 ZL Utrecht<br />
                  Telefoon: 030 720 0 888<br />
                  E-mail: info@bobarbers.nl
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Terms;
